import { CallAPI, Check, RadioHandler, GetCookieFunction } from '../../utils/util';
import { HandleTextChange, HandleSelectChange, HandleCheckChange, HandlePassChange } from '../../utils/util';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Alert from 'react-bootstrap/Alert';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class CreateUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "fName": "",
            "lName": "",
            "gender": "MALE",
            "pNum": "",
            "email": "",
            "bDay": "",
            "address1": "",
            "address2": "",
            "city": "",
            "district": "",
            "City_District_Id": null,
            "pass": "",
            "admin": "0",
            "type": "",
            "timezone": "Asia/Dhaka",
            "centerID": GetCookieFunction("Center").id,
            "centers": [],
            "citySuggestions": [],
            "showCitySuggestions": false,
            "showAddCityModal": false,
            "newLocation": { city: '', district: '' },
            "addCityModalError": ""
        };

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePassChange = HandlePassChange.bind(this);
        this.radioHandler = RadioHandler.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);
        this.handleSelectChange = HandleSelectChange.bind(this);
        this.check = Check.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.selectLocation = this.selectLocation.bind(this);

        this.modalVariant = null
        this.modalMessage = ""
    }

    componentDidMount() {
        const currentCenterId = parseInt(GetCookieFunction("Center").id);
        CallAPI({}, "centers/list", 'GET', (res) => {
            // Sort so current center is first
            const sorted = (res || []).sort((a, b) => {
                if (a.centerID === currentCenterId) return -1;
                if (b.centerID === currentCenterId) return 1;
                return a.centerID - b.centerID;
            });
            this.setState({ centers: sorted });
        });
    }

    handleCityChange(e) {
        const value = e.target.value;
        this.setState({ city: value });

        if (value.length >= 2) {
            CallAPI({}, `cityDistricts?search=${encodeURIComponent(value)}`, 'GET', (res) => {
                this.setState({
                    citySuggestions: res.data || [],
                    showCitySuggestions: true
                });
            });
        } else {
            this.setState({ citySuggestions: [], showCitySuggestions: false, district: "", City_District_Id: null });
        }
    }

    selectLocation(location) {
        this.setState({
            City_District_Id: location.id,
            city: location.city,
            district: location.district,
            citySuggestions: [],
            showCitySuggestions: false
        });
    }

    openAddCityModal = () => {
        this.setState({
            showAddCityModal: true,
            showCitySuggestions: false,
            newLocation: { city: this.state.city, district: '' },
            addCityModalError: ''
        });
    }

    closeAddCityModal = () => {
        this.setState({ showAddCityModal: false, addCityModalError: '' });
    }

    handleNewLocationChange = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            newLocation: { ...prev.newLocation, [name]: value }
        }));
    }

    saveNewLocation = (e) => {
        e.preventDefault();
        const { city, district } = this.state.newLocation;

        CallAPI({ city, district }, 'cityDistricts', 'POST', (res) => {
            if (res.success) {
                this.setState({
                    showAddCityModal: false,
                    addCityModalError: '',
                    City_District_Id: res.data.id,
                    city: res.data.city,
                    district: res.data.district
                });
            } else {
                this.setState({ addCityModalError: res.message || "This city/district already exists" });
            }
        }, () => {
            this.setState({ addCityModalError: "Failed to save. Please try again." });
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        
        CallAPI(this.state, "users/create", 'POST', (res) => {
            if (res && res.length > 0 && res[0].success){
                //TODO: Redirect somewhere
                this.modalVariant = "success"
                this.modalMessage = "The user has been created successfully."
            } else {
                // Something wrong. Show error message
                this.modalVariant = "danger"
                this.modalMessage = "The user could not be created" + (res[0].message ? ": " + res[0].message : "")
            }
            this.forceUpdate();
        }, (message) => {
            this.modalVariant = "danger"
            this.modalMessage = "The user could not be created."
            this.forceUpdate();
        });
    }

    render = () => {
        const r = (e) => this.radioHandler(e);
        return (
            <div className="ci-page">
                <div className="ci-header">
                    <h2>Create Staff Account</h2>
                    <p>Add a new staff member or manager to the system</p>
                </div>

                {this.modalVariant && (
                    <Alert variant={this.modalVariant} className="ci-alert">{this.modalMessage}</Alert>
                )}

                <form onSubmit={(e) => this.handleSubmit(e)}>

                    <div className="ci-section-title">Personal Details</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="fName" className="ci-required-label">First Name</label>
                                <input type="text" id="fName" name="fName" required maxLength="32"
                                    placeholder="First name"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="lName" className="ci-required-label">Last Name</label>
                                <input type="text" id="lName" name="lName" required maxLength="32"
                                    placeholder="Last name"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="gender" className="ci-required-label">Gender</label>
                                <select id="gender" name="gender" required onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHER">Other</option>
                                </select>
                            </div>
                            <div className="ci-field">
                                <label htmlFor="bDay" className="ci-required-label">Date of Birth</label>
                                <input type="date" id="bDay" name="bDay" required
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="timezone" className="ci-required-label">Time Zone</label>
                                <select id="timezone" name="timezone" required onChange={(e) => this.handleSelectChange(e)}>
                                    <option value="Asia/Dhaka">Asia/Dhaka</option>
                                    <option value="America/Los_Angeles">America/Los Angeles</option>
                                    <option value="America/Phoenix">America/Phoenix</option>
                                    <option value="America/Denver">America/Denver</option>
                                    <option value="America/New_York">America/New York</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Contact &amp; Address</div>
                    <div className="ci-card">
                        <div className="ci-grid">
                            <div className="ci-field">
                                <label htmlFor="pNum" className="ci-required-label">Phone Number</label>
                                <input type="tel" id="pNum" name="pNum" required
                                    pattern="^\+?[\d\s\(\)\-]+\d{4}$" maxLength="20"
                                    title="e.g. 01054 694200"
                                    placeholder="e.g. 01054 694200"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="email" className="ci-required-label">Email</label>
                                <input type="email" id="email" name="email" required
                                    placeholder="email@example.com"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="address1" className="ci-required-label">Address Line 1</label>
                                <input type="text" id="address1" name="address1" maxLength="100"
                                    placeholder="Street address"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="address2">Address Line 2</label>
                                <input type="text" id="address2" name="address2" maxLength="100"
                                    placeholder="Optional"
                                    onChange={(e) => this.handleTextChange(e)} />
                            </div>
                            <div className="ci-field ci-field-autocomplete">
                                <label htmlFor="city">City</label>
                                <input type="text" id="city" name="city" maxLength="32"
                                    placeholder="City"
                                    autoComplete="off"
                                    value={this.state.city}
                                    onChange={(e) => this.handleCityChange(e)}
                                    onBlur={() => setTimeout(() => this.setState({ showCitySuggestions: false }), 200)} />
                                {this.state.showCitySuggestions && (
                                    <ul className="ci-autocomplete-list">
                                        {this.state.citySuggestions.length > 0 ? (
                                            this.state.citySuggestions.map((loc) => (
                                                <li key={loc.id} className="ci-autocomplete-item"
                                                    onMouseDown={() => this.selectLocation(loc)}>
                                                    {loc.city} — {loc.district}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="ci-autocomplete-item ci-autocomplete-add"
                                                onMouseDown={this.openAddCityModal}>
                                                + Add new city/district
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </div>
                            <div className="ci-field">
                                <label htmlFor="district">District</label>
                                <input type="text" id="district" name="district" maxLength="32"
                                    placeholder="District"
                                    value={this.state.district}
                                    readOnly />
                            </div>
                        </div>
                    </div>

                    <div className="ci-section-title">Role &amp; Access</div>
                    <div className="ci-card">
                        <div className="ci-grid ci-grid-2">
                            <div className="ci-field">
                                <div className="ci-card-label ci-required-label">User Type</div>
                                <div className="ci-radio-group">
                                    <label className="ci-radio-option">
                                        <input type="radio" id="type1" name="type" value="doctor" required onChange={r} />
                                        <span>Doctor</span>
                                    </label>
                                    <label className="ci-radio-option">
                                        <input type="radio" id="type2" name="type" value="nurse" onChange={r} />
                                        <span>Nurse</span>
                                    </label>
                                    <label className="ci-radio-option">
                                        <input type="radio" id="type3" name="type" value="centeradmin" onChange={r} />
                                        <span>Center Admin</span>
                                    </label>
                                    {GetCookieFunction("User").type === 'executive' && (
                                        <label className="ci-radio-option">
                                            <input type="radio" id="type4" name="type" value="executive" onChange={r} />
                                            <span>Executive</span>
                                        </label>
                                    )}
                                </div>
                            </div>
                            {this.state.type !== 'executive' && (
                                <div className="ci-field">
                                    <label htmlFor="centerID" className="ci-required-label">Assigned Center</label>
                                    <select id="centerID" name="centerID" required
                                        value={this.state.centerID}
                                        onChange={(e) => this.handleSelectChange(e)}>
                                        {this.state.centers.map(c => (
                                            <option key={c.centerID} value={c.centerID}>{c.centerName}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="ci-card">
                        <label className="ci-checkbox-label" style={{ opacity: (this.state.type === 'centeradmin' || this.state.type === 'executive') ? 0.5 : 1 }}>
                            <input type="checkbox" name="admin"
                                disabled={this.state.type === 'centeradmin' || this.state.type === 'executive'}
                                checked={this.state.type !== 'centeradmin' && this.state.type !== 'executive' && this.state.admin === true}
                                onChange={(e) => this.handleCheckChange(e)} />
                            <div>
                                <span>User has administrative privileges</span>
                                <p style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '4px' }}>
                                    {(this.state.type === 'centeradmin' || this.state.type === 'executive')
                                        ? "Not applicable — this role has built-in admin access."
                                        : "If checked, this user can create other users and perform admin operations."
                                    }
                                </p>
                            </div>
                        </label>
                    </div>

                    <div className="ci-section-title">Password</div>
                    <div className="ci-card">
                        <div className="ci-grid ci-grid-2">
                            <div className="ci-field">
                                <label htmlFor="pass" className="ci-required-label">Password</label>
                                <input type="password" id="pass" name="pass" required
                                    placeholder="Enter password"
                                    onChange={(e) => this.handlePassChange(e, this)} />
                            </div>
                            <div className="ci-field">
                                <label htmlFor="password" className="ci-required-label">Confirm Password</label>
                                <input type="password" id="password" name="password" required
                                    placeholder="Confirm password"
                                    onChange={(e) => this.check(e, this)} />
                            </div>
                        </div>
                    </div>

                    <div className="ci-submit-row">
                        <button type="submit" className="logSubmit ci-submit-btn">Create Staff Account</button>
                    </div>
                </form>

                {/* ── Add City/District Modal ── */}
                {this.state.showAddCityModal && (
                    <div className="ci-modal-overlay" onClick={this.closeAddCityModal}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Add New City/District</h3>
                            {this.state.addCityModalError ? (
                                <div>
                                    <p className="ci-modal-error">{this.state.addCityModalError}</p>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Close">✕</button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.saveNewLocation}>
                                    <div className="ci-field">
                                        <label>City</label>
                                        <input type="text" name="city" required maxLength="45"
                                            value={this.state.newLocation.city}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label>District</label>
                                        <input type="text" name="district" required maxLength="45"
                                            value={this.state.newLocation.district}
                                            onChange={this.handleNewLocationChange} />
                                    </div>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddCityModal} title="Cancel">✕</button>
                                        <button type="submit" className="ci-modal-icon-btn ci-modal-save" title="Save">✓</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };
}

export default withRouter(CreateUser)